<template lang="pug">
#home
  h2.mb-3(@click="home") {{ me.homeHeading }}
  p {{ me.about }}
  .mt-5.mb-n3
    .d-flex.align-items-top.mb-3(
      v-for="detail in me.details",
      :key="detail.key"
    )
      v-icon.round-icon.text-white.mr-2.flex-shrink-0(
        scale="2",
        :name="detail.icon",
        :class="`bg-${detail.class}`"
      )
      a(:href="detail.link", target="blank", v-if="detail.link") {{ detail.value }}
      span(v-else) {{ detail.value }}

  //- b-row(align-v="stretch", style="margin-bottom: -30px")
  //-   b-col(style="margin-bottom: 30px", cols="4")
  //-     .d-flex.flex-column.h-100.text-white.justify-content-between.p-3.bg-adept
  //-       .mb-3
  //-         a.text-white(:href="me.profile.email") {{ me.profile.email }}
  //-         a.text-white {{ me.profile.employer }}
  //-       v-icon(scale="2", name="mail")
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapState(["me"]),
    items() {
      return this.me.details;
    },
  },
  methods: {
    home() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="postcss">
.round-icon {
  width: 25px;
  height: 25px;
  border-radius: 5px;
  padding: 5px;
}
</style>
